import { Input } from 'components/Input/Input'
import { Container, ContainerContent, ContainerHeader, IconContainer } from '../Accommodation.style'
import { StatusPill } from 'components/ui/StatusPill/StatusPill'
import { Box, Flex, PageFooter } from 'styling/GlobalStyles'
import { BodyText, OtherText, TitleText } from 'styling/Typography'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { LocationIcon } from '../icons/LocationIcon'
import { NextIcon } from '../icons/NextIcon'
import { CalendarIcon } from '../icons/CalendarIcon'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { KeyboardEvent, useEffect, useState } from 'react'
import { checkOut, getCheckouts } from 'features/accommodation/accommodationSlice'
import { Pagination } from 'components/Pagination/Pagination'
import { formatDateForDisplay, getDateDifference, getParams, handlePagination } from 'utils/helpers'
import { IGetAllExpectedCheckoutsSingleResponse } from 'types/api/accommodationApi.interface'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { setConfirmModal } from 'features/global/globalSlice'
import { ModalTypes } from 'types/global.interface'
import { WhitePersonIcon } from '../icons/WhitePersonIcon'
import { tierOptions } from './CheckIn'
import { ISelectValue } from 'constants/globalTypes'
import { CloseIcon } from 'assets/icons/CloseIcon'
import { tokens } from 'styling/tokens'

export const CheckOut = () => {
    const [params, setParams] = useState(getParams({ location, limit: 30, ap: { date: new Date() } }))
    const [searchValue, setSearchValue] = useState('')
    const dispatch = useDispatch<AppDispatch>()
    const { checkOuts } = useSelector((state: RootState) => state.accomodation)

    useEffect(() => {
        dispatch(getCheckouts(params))
    }, [params])

    const handleSearch = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key !== 'Enter') return

        const value = searchValue.trim()
        setParams((prev) => {
            const { q, ...rest } = prev
            return {
                ...rest,
                page: 1,
                ...(value ? { q: value } : {}),
            }
        })
    }

    const clearSearch = () => {
        setSearchValue('')
        setParams((prev) => {
            const { q, ...rest } = prev
            return {
                ...rest,
                page: 1,
            }
        })
    }

    const NoBeds = () => {
        return <Flex center justcenter height='100%' column gap='1rem' >
            <IconContainer>
                <WhitePersonIcon />
            </IconContainer>
            <TitleText>There are no checkouts for selected date</TitleText>
        </Flex>
    }

    const Bed = ({ data }: { data: IGetAllExpectedCheckoutsSingleResponse }) => {

        const handleCheckOut = (id: number) => {
            dispatch(
                setConfirmModal({
                    isOpen: true,
                    onSave: async () => {
                        await dispatch(checkOut(id))
                    },
                    setParams: {
                        type: ModalTypes.BeforeSabe,
                        f: setParams,
                        noItems: checkOuts.data.length < 2,
                    },
                    word: 'check out this person',
                }),
            )
        }
        return <Box style={{ cursor: 'pointer' }} className='hover' onClick={() => handleCheckOut(data.id)}>
            <Flex column gap='1rem' >
                <Flex width='100%' between >
                    <TitleText>{data.user ? (data.user.firstName + ' ' + data.user?.lastName) : (data.accommodationGuest?.firstName + ' ' + data.accommodationGuest?.lastName)}</TitleText>
                    <StatusPill status={data.personType == 1 ? 'info' : 'neutral'}>{data.personType == 1 ? 'Employee' : 'Guest'}</StatusPill>
                </Flex>
                <Flex gap='0.5rem ' >
                    <LocationIcon />
                    <BodyText grey > {data.campName}</BodyText>
                    <NextIcon />
                    <BodyText grey > {data.blockName}</BodyText>
                    <NextIcon />
                    <BodyText grey > {data.roomName}</BodyText>
                    <NextIcon />
                    <BodyText color={tokens.accent.base} > {data.bed.label}</BodyText>
                </Flex>
                <OtherText grey >{data.gender == 'm' ? 'Male' : 'Female'} •  {tierOptions.find(t => t.value == data.tier)?.label}</OtherText>
                <Flex width='100%' between >
                    <Flex gap='1rem' >
                        <Flex gap='0.5rem' center >
                            <CalendarIcon />
                            <OtherText grey>In: {formatDateForDisplay(data.checkInTimestamp)}</OtherText>
                        </Flex>
                        <Flex gap='0.5rem' center >
                            <CalendarIcon />
                            <OtherText grey>Out: {formatDateForDisplay(data.expectedCheckOutTimestamp)}</OtherText>
                        </Flex>
                    </Flex>
                    <BodyText color={tokens.status.success.fg} >{getDateDifference(data.checkInTimestamp, data.expectedCheckOutTimestamp)}</BodyText>
                </Flex>
            </Flex>
        </Box>
    }

    return <>
        <Flex gap='1rem' alignEnd mb='16' >
            <Input
                search
                nomarg
                width='350px'
                placeholder='Search by name'
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                onKeyUp={handleSearch}
                rightIcon={params.q ? <CloseIcon /> : null}
                onRightIconClick={params.q ? clearSearch : undefined}
            />
            <CalendarInput nomarg defaultValue={params.date} labelText='Date' onChange={date => setParams(prev => ({ ...prev, date }))} />
        </Flex>
        <Container>
            <ContainerHeader padding>
                <Flex column gap='1rem' >
                    <TitleText>Currently Occupied Beds</TitleText>
                    <Flex gap='1rem' >
                        {/* <HonestSelectInput width='200px' nomarg options={[]} onChange={null} labelText='Camp' /> */}
                        <HonestSelectInput width='200px' nomarg defaultValue={params.tier} options={tierOptions} onChange={(v: ISelectValue) => setParams(prev => ({ ...prev, tier: v?.value }))} labelText='Tier' />
                    </Flex>
                </Flex>
            </ContainerHeader>
            <ContainerContent gap='1rem' >
                {checkOuts?.data?.length ? checkOuts?.data?.map((item) => (
                    <Bed data={item} key={item.id} />
                )) : <NoBeds />}
            </ContainerContent>
        </Container>
        <PageFooter>
            <Pagination
                setPage={(page) => handlePagination(page, setParams, 30)}
                pageCount={Math.ceil(checkOuts.totalPages)}
                forcePage={(params.page ? params.page : 1) - 1}
            />
        </PageFooter>
    </>
}